// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { FileInfoResponse } from './file-info-response';

// @ts-ignore
import { MessageParticipantNameResponse } from './message-participant-name-response';

/** See com.rev360.pms.api.controller.messaging.MessageDetailResponse */
/* istanbul ignore next */
@GandalfModel
export class MessageDetailResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Date })
	createdOn!: Date | null;

	@GandalfProperty({ designType: String })
	messageContent!: string | null;

	@GandalfArray(FileInfoResponse)
	messageFiles!: FileInfoResponse[];

	@GandalfProperty({ designType: Number })
	messageId!: number;

	@GandalfProperty({ designType: Number })
	messageParticipantId!: number;

	@GandalfProperty({ designType: Number })
	parentMessageId!: number | null;

	@GandalfArray(MessageParticipantNameResponse)
	participants!: MessageParticipantNameResponse[];

	@GandalfConstantDecorator(constants.MessagePriority)
	@GandalfProperty({ designType: constants.MessagePriority })
	priority!: constants.MessagePriority | null;

	@GandalfProperty({ designType: Number })
	rootMessageId!: number | null;

	@GandalfProperty({ designType: MessageParticipantNameResponse })
	sender!: MessageParticipantNameResponse;

	@GandalfProperty({ designType: String })
	subject!: string;

}
